import { render, staticRenderFns } from "./customer-of-system.vue?vue&type=template&id=3e0d1a66"
import script from "./customer-of-system.vue?vue&type=script&lang=js"
export * from "./customer-of-system.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports